import React from "react";
import classnames from "classnames";

import { FlagIcon, WarningIcon } from "fe-shared/src/components/Icons";
import { TransactionFlag } from "fe-shared-transactions/src/types";
import { FLAG_COLOR, WARNING_COLOR } from "../../consts";

import styles from "./FlagComments.module.scss";

interface Props {
  flags: TransactionFlag[];
}

const FlagComments = ({ flags = [] }: Props) => {
  const sortedFlag = [
    flags.filter((item) => item.isManual),
    flags.filter((item) => !item.isManual),
  ].filter((item) => item.length);

  return (
    <>
      {sortedFlag.map((flagsItem, indx) => {
        const { isManual } = flagsItem[0];
        const isList = flagsItem.length > 1;

        return (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={indx}
            className={classnames(styles.transactionFlagComment, {
              [styles.transactionFlagCommentManual]: isManual,
            })}
          >
            {isManual ? (
              <FlagIcon fillColor={FLAG_COLOR} />
            ) : (
              <WarningIcon fillColor={WARNING_COLOR} />
            )}
            <div>
              {flagsItem.map((item) => (
                <pre
                  key={item.text}
                  className={
                    isList ? styles.transactionFlagCommentListItem : ""
                  }
                >
                  {item.text}
                </pre>
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FlagComments;
